import { AbstractControl, ValidationErrors } from "@angular/forms";

export class EventValidator {
    static validBookingTiming(control: AbstractControl): ValidationErrors | null {
        if (!control) { return null };

        const reservationDate = control.get('reservationDate');
        if (!reservationDate.value) { return null };

        const rd = reservationDate.value instanceof Date ? reservationDate.value : reservationDate.value._d;

        const fromTime = control.get('fromTime');
        const toTime = control.get('toTime');
        const minDuration = 1000 * 60 * 30;
        if (!fromTime.value || !toTime.value) { return null };
        

        const targetDate = {
            year: rd.getFullYear(),
            month: rd.getMonth(),
            date: rd.getDate()
        };

        const ft = fromTime.value;
        ft.setFullYear(targetDate.year);
        ft.setMonth(targetDate.month);
        ft.setDate(targetDate.date);

        const tt = toTime.value;
        tt.setFullYear(targetDate.year);
        tt.setMonth(targetDate.month);
        tt.setDate(targetDate.date);

        
        if (ft.getTime() > (tt.getTime() - minDuration)) {
            // console.log({ invalidEndTime: { min: new Date(ft.getTime() + minDuration), current: tt.value }});
            return { invalidEndTime: { min: new Date(ft.getTime() + minDuration), current: tt.value }};
        }

        return null;
    }

}